// Global Types
import type {
  $Translate,
} from 'common.language';
import type {
  $Model,
} from 'common.data';

// Global Components
import * as React from 'react';
import {
  AvForm,
} from 'availity-reactstrap-validation';
import {
  InputNumber,
} from '@vroskus/library-components';

// Types
type $Props = $Translate & {
  item: $Model<'ChampionshipResultTableRaceResult'>;
  onChange: (arg0: $Model<'ChampionshipResultTableRaceResult'>) => unknown;
};

const ChampionshipResultTableRaceResultFieldsView = function ({
  item,
  onChange,
  t,
}: $Props) {
  return (
    <AvForm>
      <InputNumber
        className={'mb-0-i'}
        min={0}
        name={'Value'}
        onChange={(value) => onChange({
          ...item,
          Value: value,
        })}
        placeholder={t('Value')}
        value={item.Value}
      />
    </AvForm>
  );
};

export default ChampionshipResultTableRaceResultFieldsView;
